/**
 * PDF.js needs explicit URLs for CMaps, standard fonts, and ICC data when the
 * library is bundled. Without these, some PDFs render missing or very faint
 * text while vectors/annotations still appear.
 *
 * Paths mirror the published `pdfjs-dist` package layout on npm/CDN.
 */
export const getPdfJsDistAssetBase = (version: string): string =>
  `https://cdn.jsdelivr.net/npm/pdfjs-dist@${version}/`;

export const getPdfDocumentLoadParamsForUrl = (url: string, version: string) => {
  const base = getPdfJsDistAssetBase(version);
  return {
    url,
    cMapUrl: `${base}cmaps/`,
    cMapPacked: true,
    standardFontDataUrl: `${base}standard_fonts/`,
    iccUrl: `${base}iccs/`,
    wasmUrl: `${base}wasm/`,
    useWorkerFetch: true as const,
    // CVE-2026-16633: scripting enabled by default; keep off for untrusted PDFs.
    enableScripting: false as const,
    /**
     * When false, PDF.js paints glyphs via @font-face from embedded fonts.
     * Some generator/subset combinations paint as blank or nearly invisible in
     * canvas while strokes and annotation ink still show — path rendering avoids that.
     */
    disableFontFace: true as const
  };
};

export const getPdfDocumentLoadParamsForData = (
  data: ArrayBuffer | Uint8Array,
  version: string
) => {
  const base = getPdfJsDistAssetBase(version);
  return {
    data,
    cMapUrl: `${base}cmaps/`,
    cMapPacked: true,
    standardFontDataUrl: `${base}standard_fonts/`,
    iccUrl: `${base}iccs/`,
    wasmUrl: `${base}wasm/`,
    useWorkerFetch: true as const,
    enableScripting: false as const,
    disableFontFace: true as const
  };
};
